import { requestGet, requestPost } from '@/utils/request';

// 正在打卡
export function getCampUnderwayList() {
  return requestGet(`/v2/camp/api/study/my/all/study/list?stateArray=1,2,3,4&size=3`, {});
}

// 获取学习报名数据-报名id
export function getSignUp(signUpId: string) {
  return requestGet(`/v2/camp/api/study/sign/id/${signUpId}`, {});
}

// 学员报名批次的基础信息
export function studentBaseInfo(batchId: string) {
  return requestGet(`/v2/camp/api/study/batch/id/${batchId}`, {});
}

// 学习节点进度-报名id
export function getNodeProgress(signUpId: string) {
  return requestGet(`/v2/camp/api/study/node/progress/${signUpId}`, {});
}

// 通过节点id获取内容模块
export function getNodeContent(nodeId: string) {
  return requestGet(`/v2/camp/api/study/content/${nodeId}`, {});
}

// 获取习题结果状态
export function getExercisesResults(studyNodeId: string) {
  return requestGet(`/v2/camp/api/study/exercises/results/${studyNodeId}`, {});
}

// 提交节点
export function postNode(params: any) {
  return requestPost(`/v2/camp/api/study/node/submit`, params);
}
// 保存节点
export function postNodeSave(params: any) {
  return requestPost(`/v2/camp/api/study/node/save`, params);
}

// 学习报告
export function getStudyReport(batchId: string) {
  return requestGet(`/v2/camp/api/study/report/${batchId}`, {});
}
// 通过批次检查报名是否存在
export function getStudyCheck(batchId: string) {
  return requestGet(`/v2/camp/api/study/entry/check/${batchId}`, {});
}
